import { render } from "./LightboxLastOrder.vue?vue&type=template&id=4da9c56f"
import script from "./LightboxLastOrder.vue?vue&type=script&lang=js"
export * from "./LightboxLastOrder.vue?vue&type=script&lang=js"

import "./LightboxLastOrder.vue?vue&type=style&index=0&id=4da9c56f&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__